import React from 'react';
import { drapcodeIcon } from '../custom/icon-library';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Zoom from '@material-ui/core/Zoom';
import parse from 'html-react-parser';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 250,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

const defaultChild = (cursor, icon, iconColor) => {
  return (
    <span style={{ cursor: cursor, color: iconColor }}>
      <i className={`wb ${drapcodeIcon(icon)}`}></i>
    </span>
  );
};

const appendDefaultChild = (cursor, icon, iconColor) => {
  return (
    <div className="input-group-append">
      <span className="input-group-text">
        <span style={{ cursor: cursor, color: iconColor }}>
          <i className={`wb ${drapcodeIcon(icon)}`}></i>
        </span>
      </span>
    </div>
  );
};

const TooltipInfo = ({
  icon = 'description',
  headerText,
  title,
  prefix,
  cursor = 'default',
  isHtml = true,
  showArrow = false,
  showHeader = false,
  append = false,
  iconColor = 'inherit',
  children,
}) => {
  const defaultTitleHeader = headerText ? headerText : `What's this?`;
  return (
    <>
      {prefix}
      <HtmlTooltip
        title={
          <React.Fragment>
            <Typography color="inherit" style={{ marginBottom: '10px' }}>
              {showHeader && defaultTitleHeader}
            </Typography>
            {isHtml && title ? parse(title) : title}
          </React.Fragment>
        }
        TransitionComponent={Zoom}
        disableFocusListener
        arrow={showArrow}
      >
        {children
          ? children
          : append
          ? appendDefaultChild(cursor, icon, iconColor)
          : defaultChild(cursor, icon, iconColor)}
      </HtmlTooltip>
    </>
  );
};

export default TooltipInfo;
